const CastroJS = {
  init: function () {
    this.config()
    this.events()
  },

  config: function() {
    this.config = {
      $window: $(window),
      $document: $(document),
    }
  },

  events: function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this

    self.config.$document.ready(function () {
      self.preLoader()
    })
  },

  preLoader: function () {
    $('#layout-loader').delay(1000).fadeOut(500)
  },
}

export { CastroJS }